import * as t from 'io-ts';
import { AlertCodec } from 'src/components/alerts/types';

// Define the main alert type
export const NotificationsCodec = t.type({
  content: t.array(AlertCodec),
});

export type Notifications = t.TypeOf<typeof NotificationsCodec>;
